// Nameing: PAGE_ACTION_STATUS

export const APP_LOGIN_SET = 'app/login/set'
export const APP_LOGOUT_SET = 'app/logout/set'

export const PARAM_SET = 'param/set'

export const LOGIN_EDITFORM_CHANGE = 'login/editForm/change'
export const LOGIN_LOGIN_LOAD = 'login/login/load'
export const LOGIN_LOGIN_SUCCEED = 'login/login/succeed'
export const LOGIN_LOGIN_FAIL = 'login/login/fail'

export const ADMIN_OPENSUBMENU_CHANGE = 'admin/openSubMenu/change'

export const SELLERLIST_FETCHITEMS_LOAD = 'sellerLists/fetchItems/load'
export const SELLERLIST_FETCHITEMS_SUCCEED = 'sellerLists/fetchItems/succeed'
export const SELLERLIST_FETCHITEMS_FAIL = 'sellerLists/fetchItems/fail'
export const SELLERLIST_CHANGETABLE_CHANGE = 'sellerLists/changeTable/change'
export const SELLERLIST_SEARCHTABLE_EDIT = 'sellerLists/searchTable/edit'
export const SELLERLIST_SEARCHTABLE_SEARCH = 'sellerLists/searchTable/search'
export const SELLERLIST_FETCHGROUPS_LOAD = 'sellerLists/fetchGroups/load'
export const SELLERLIST_FETCHGROUPS_SUCCEED = 'sellerLists/fetchGroups/succeed'
export const SELLERLIST_FETCHGROUPS_FAIL = 'sellerLists/fetchGroups/fail'

export const SELLERLIST_GROUPFORM_FETCHITEMS_LOAD = 'sellerLists/groupForm/fetchItems/load'
export const SELLERLIST_GROUPFORM_FETCHITEMS_SUCCEED = 'sellerLists/groupForm/fetchItems/succeed'
export const SELLERLIST_GROUPFORM_FETCHITEMS_FAIL = 'sellerLists/groupForm/fetchItems/fail'
export const SELLERLIST_GROUPFORM_FETCHITEMS_LAZY_LOADING_SUCCEED = 'sellerLists/groupForm/fetchItemsLazyLoading/succeed'
export const SELLERLIST_GROUPFORM_FETCHITEMS_CHANGE_PAGINATION = 'sellerLists/groupForm/changePagination'
export const SELLERLIST_GROUPFORM_ITEMS_HAS_NO_MORE = 'sellerLists/groupForm/items/hasNoMore'
export const SELLERLIST_GROUPFORM_FETCH_GROUPITEMS_LOAD = 'sellerLists/groupForm/fetchGroupItems/load'
export const SELLERLIST_GROUPFORM_FETCH_GROUPITEMS_SUCCEED = 'sellerLists/groupForm/fetchGroupItems/succeed'
export const SELLERLIST_GROUPFORM_FETCH_GROUPITEMS_FAIL = 'sellerLists/groupForm/fetchGroupItems/fail'

export const SELLERLIST_GROUPFORM_CHANGE = 'sellerLists/groupForm/change'
export const SELLERLIST_GROUPFORM_CREATE_LOAD = 'sellerLists/groupForm/create/load'
export const SELLERLIST_GROUPFORM_CREATE_SUCCEED = 'sellerLists/groupForm/create/succeed'
export const SELLERLIST_GROUPFORM_CREATE_FAIL = 'sellerLists/groupForm/create/fail'
export const SELLERLIST_GROUPFORM_REMOVE_LOAD = 'sellerLists/groupForm/remove/load'
export const SELLERLIST_GROUPFORM_REMOVE_SUCCEED = 'sellerLists/groupForm/remove/succeed'
export const SELLERLIST_GROUPFORM_REMOVE_FAIL = 'sellerLists/groupForm/remove/fail'
export const SELLERLIST_GROUPFORM_EDIT_LOAD = 'sellerLists/groupForm/edit/load'
export const SELLERLIST_GROUPFORM_EDIT_SUCCEED = 'sellerLists/groupForm/edit/succeed'
export const SELLERLIST_GROUPFORM_EDIT_FAIL = 'sellerLists/groupForm/edit/fail'


export const SELLERFORM_ENTER_RESET = 'sellerForm/enter/reset'
export const SELLERFORM_EDITFORM_CHANGE = 'sellerForm/editForm/change'
export const SELLERFORM_FETCHITEM_LOAD = 'sellerForm/fetchItem/load'
export const SELLERFORM_FETCHITEM_SUCCEED = 'sellerForm/fetchItem/succeed'
export const SELLERFORM_FETCHITEM_FAIL = 'sellerForm/fetchItem/fail'
export const SELLERFORM_CREATEITEM_LOAD = 'sellerForm/createItem/load'
export const SELLERFORM_CREATEITEM_SUCCEED = 'sellerForm/createItem/succeed'
export const SELLERFORM_CREATEITEM_FAIL = 'sellerForm/createItem/fail'
export const SELLERFORM_EDITITEM_LOAD = 'sellerForm/editItem/load'
export const SELLERFORM_EDITITEM_SUCCEED = 'sellerForm/editItem/succeed'
export const SELLERFORM_EDITITEM_FAIL = 'sellerForm/editItem/fail'
export const SELLERFORM_DELETEITEM_LOAD = 'sellerForm/deleteItem/load'
export const SELLERFORM_DELETEITEM_SUCCEED = 'sellerForm/deleteItem/succeed'
export const SELLERFORM_DELETEITEM_FAIL = 'sellerForm/deleteItem/fail'

export const SELLERPOINTLIST_FETCHITEMS_LOAD = 'sellerPointLists/fetchItems/load'
export const SELLERPOINTLIST_FETCHITEMS_SUCCEED = 'sellerPointLists/fetchItems/succeed'
export const SELLERPOINTLIST_FETCHITEMS_FAIL = 'sellerPointLists/fetchItems/fail'
export const SELLERPOINTLIST_CHANGETABLE_CHANGE = 'sellerPointLists/changeTable/change'
export const SELLERPOINTLIST_SEARCHTABLE_EDIT = 'sellerPointLists/searchTable/edit'
export const SELLERPOINTLIST_SEARCHTABLE_SEARCH = 'sellerPointLists/searchTable/search'

export const SELLERPOINTFORM_ENTER_RESET = 'sellerPointForm/enter/reset'
export const SELLERPOINTFORM_EDITFORM_CHANGE = 'sellerPointForm/editForm/change'
export const SELLERPOINTFORM_FETCHITEM_LOAD = 'sellerPointForm/fetchItem/load'
export const SELLERPOINTFORM_FETCHITEM_SUCCEED = 'sellerPointForm/fetchItem/succeed'
export const SELLERPOINTFORM_FETCHITEM_FAIL = 'sellerPointForm/fetchItem/fail'
export const SELLERPOINTFORM_CREATEITEM_LOAD = 'sellerPointForm/createItem/load'
export const SELLERPOINTFORM_CREATEITEM_SUCCEED = 'sellerPointForm/createItem/succeed'
export const SELLERPOINTFORM_CREATEITEM_FAIL = 'sellerPointForm/createItem/fail'
export const SELLERPOINTFORM_EDITITEM_LOAD = 'sellerPointForm/editItem/load'
export const SELLERPOINTFORM_EDITITEM_SUCCEED = 'sellerPointForm/editItem/succeed'
export const SELLERPOINTFORM_EDITITEM_FAIL = 'sellerPointForm/editItem/fail'
export const SELLERPOINTFORM_DELETEITEM_LOAD = 'sellerPointForm/deleteItem/load'
export const SELLERPOINTFORM_DELETEITEM_SUCCEED = 'sellerPointForm/deleteItem/succeed'
export const SELLERPOINTFORM_DELETEITEM_FAIL = 'sellerPointForm/deleteItem/fail'

export const SELLERCHATLIST_FETCHITEMS_LOAD = 'sellerChatLists/fetchItems/load'
export const SELLERCHATLIST_FETCHITEMS_SUCCEED = 'sellerChatLists/fetchItems/succeed'
export const SELLERCHATLIST_FETCHITEMS_FAIL = 'sellerChatLists/fetchItems/fail'
export const SELLERCHATLIST_CHANGETABLE_CHANGE = 'sellerChatLists/changeTable/change'
export const SELLERCHATLIST_SEARCHTABLE_EDIT = 'sellerChatLists/searchTable/edit'
export const SELLERCHATLIST_SEARCHTABLE_SEARCH = 'sellerChatLists/searchTable/search'

export const SELLERCHATFORM_ENTER_RESET = 'sellerChatForm/enter/reset'
export const SELLERCHATFORM_EDITFORM_CHANGE = 'sellerChatForm/editForm/change'
export const SELLERCHATFORM_FETCHITEM_LOAD = 'sellerChatForm/fetchItem/load'
export const SELLERCHATFORM_FETCHITEM_SUCCEED = 'sellerChatForm/fetchItem/succeed'
export const SELLERCHATFORM_FETCHITEM_FAIL = 'sellerChatForm/fetchItem/fail'
export const SELLERCHATFORM_CREATEITEM_LOAD = 'sellerChatForm/createItem/load'
export const SELLERCHATFORM_CREATEITEM_SUCCEED = 'sellerChatForm/createItem/succeed'
export const SELLERCHATFORM_CREATEITEM_FAIL = 'sellerChatForm/createItem/fail'
export const SELLERCHATFORM_EDITITEM_LOAD = 'sellerChatForm/editItem/load'
export const SELLERCHATFORM_EDITITEM_SUCCEED = 'sellerChatForm/editItem/succeed'
export const SELLERCHATFORM_EDITITEM_FAIL = 'sellerChatForm/editItem/fail'
export const SELLERCHATFORM_DELETEITEM_LOAD = 'sellerChatForm/deleteItem/load'
export const SELLERCHATFORM_DELETEITEM_SUCCEED = 'sellerChatForm/deleteItem/succeed'
export const SELLERCHATFORM_DELETEITEM_FAIL = 'sellerChatForm/deleteItem/fail'

export const SELLERBALANCEFORM_ENTER_RESET = 'sellerBalanceForm/enter/reset'
export const SELLERBALANCEFORM_EDITFORM_CHANGE = 'sellerBalanceForm/editForm/change'
export const SELLERBALANCEFORM_ADDITEM_LOAD = 'sellerBalanceForm/addItem/load'
export const SELLERBALANCEFORM_ADDITEM_SUCCEED = 'sellerBalanceForm/addItem/succeed'
export const SELLERBALANCEFORM_ADDITEM_FAIL = 'sellerBalanceForm/addItem/fail'

export const SELLERBUTTONMENUFORM_ENTER_RESET = 'sellerButtonMenuForm/enter/reset'
export const SELLERBUTTONMENUFORM_FETCHITEMS_LOAD = 'sellerButtonMenuForm/fetchItems/load'
export const SELLERBUTTONMENUFORM_FETCHITEMS_SUCCEED = 'sellerButtonMenuForm/fetchItems/succeed'
export const SELLERBUTTONMENUFORM_FETCHITEMS_FAIL = 'sellerButtonMenuForm/fetchItems/fail'
export const SELLERBUTTONMENUFORM_EDITFORM_CHANGE = 'sellerButtonMenuForm/editForm/change'
export const SELLERBUTTONMENUFORM_EDITITEM_LOAD = 'sellerButtonMenuForm/editItem/load'
export const SELLERBUTTONMENUFORM_EDITITEM_SUCCEED = 'sellerButtonMenuForm/editItem/succeed'
export const SELLERBUTTONMENUFORM_EDITITEM_FAIL = 'sellerButtonMenuForm/editItem/fail'

export const ACTIONLIST_FETCHITEMS_LOAD = 'actionLists/fetchItems/load'
export const ACTIONLIST_FETCHITEMS_SUCCEED = 'actionLists/fetchItems/succeed'
export const ACTIONLIST_FETCHITEMS_FAIL = 'actionLists/fetchItems/fail'
export const ACTIONLIST_CHANGETABLE_CHANGE = 'actionLists/changeTable/change'
export const ACTIONLIST_SEARCHTABLE_EDIT = 'actionLists/searchTable/edit'
export const ACTIONLIST_SEARCHTABLE_SEARCH = 'actionLists/searchTable/search'

export const ACTIONFORM_ENTER_RESET = 'actionForm/enter/reset'
export const ACTIONFORM_EDITFORM_CHANGE = 'actionForm/editForm/change'
export const ACTIONFORM_FETCHITEM_LOAD = 'actionForm/fetchItem/load'
export const ACTIONFORM_FETCHITEM_SUCCEED = 'actionForm/fetchItem/succeed'
export const ACTIONFORM_FETCHITEM_FAIL = 'actionForm/fetchItem/fail'
export const ACTIONFORM_CREATEITEM_LOAD = 'actionForm/createItem/load'
export const ACTIONFORM_CREATEITEM_SUCCEED = 'actionForm/createItem/succeed'
export const ACTIONFORM_CREATEITEM_FAIL = 'actionForm/createItem/fail'
export const ACTIONFORM_EDITITEM_LOAD = 'sellerForm/editItem/load'
export const ACTIONFORM_EDITITEM_SUCCEED = 'actionForm/editItem/succeed'
export const ACTIONFORM_EDITITEM_FAIL = 'actionForm/editItem/fail'
export const ACTIONFORM_DELETEITEM_LOAD = 'actionForm/deleteItem/load'
export const ACTIONFORM_DELETEITEM_SUCCEED = 'actionForm/deleteItem/succeed'
export const ACTIONFORM_DELETEITEM_FAIL = 'actionForm/deleteItem/fail'

export const GOODS_FETCHITEMS_LOAD = 'goods/fetchItem/load'
export const GOODS_FETCHITEMS_SUCCEED = 'goods/fetchItem/succeed'
export const GOODS_FETCHITEMS_FAIL = 'goods/fetchItem/fail'

export const SELLERS_FETCHITEMS_LOAD = 'sellers/fetchItem/load'
export const SELLERS_FETCHITEMS_SUCCEED = 'sellers/fetchItem/succeed'
export const SELLERS_FETCHITEMS_FAIL = 'sellers/fetchItem/fail'

export const USERLIST_FETCHITEMS_LOAD = 'userLists/fetchItems/load'
export const USERLIST_FETCHITEMS_SUCCEED = 'userLists/fetchItems/succeed'
export const USERLIST_FETCHITEMS_FAIL = 'userLists/fetchItems/fail'
export const USERLIST_CHANGETABLE_CHANGE = 'userLists/changeTable/change'
export const USERLIST_SEARCHTABLE_EDIT = 'userLists/searchTable/edit'
export const USERLIST_SEARCHTABLE_SEARCH = 'userLists/searchTable/search'

export const USERFORM_ENTER_RESET = 'userForm/enter/reset'
export const USERFORM_EDITFORM_CHANGE = 'userForm/editForm/change'
export const USERFORM_FETCHITEM_LOAD = 'userForm/fetchItem/load'
export const USERFORM_FETCHITEM_SUCCEED = 'userForm/fetchItem/succeed'
export const USERFORM_FETCHITEM_FAIL = 'userForm/fetchItem/fail'
export const USERFORM_CREATEITEM_LOAD = 'userForm/createItem/load'
export const USERFORM_CREATEITEM_SUCCEED = 'userForm/createItem/succeed'
export const USERFORM_CREATEITEM_FAIL = 'userForm/createItem/fail'
export const USERFORM_EDITITEM_LOAD = 'userForm/editItem/load'
export const USERFORM_EDITITEM_SUCCEED = 'userForm/editItem/succeed'
export const USERFORM_EDITITEM_FAIL = 'userForm/editItem/fail'
export const USERFORM_DELETEITEM_LOAD = 'userForm/deleteItem/load'
export const USERFORM_DELETEITEM_SUCCEED = 'userForm/deleteItem/succeed'
export const USERFORM_DELETEITEM_FAIL = 'userForm/deleteItem/fail'

export const ROLELIST_FETCHITEMS_LOAD = 'roleLists/fetchItems/load'
export const ROLELIST_FETCHITEMS_SUCCEED = 'roleLists/fetchItems/succeed'
export const ROLELIST_FETCHITEMS_FAIL = 'roleLists/fetchItems/fail'
export const ROLELIST_CHANGETABLE_CHANGE = 'roleLists/changeTable/change'
export const ROLELIST_SEARCHTABLE_EDIT = 'roleLists/searchTable/edit'
export const ROLELIST_SEARCHTABLE_SEARCH = 'roleLists/searchTable/search'

export const ROLEFORM_ENTER_RESET = 'roleForm/enter/reset'
export const ROLEFORM_EDITFORM_CHANGE = 'roleForm/editForm/change'
export const ROLEFORM_FETCHITEM_LOAD = 'roleForm/fetchItem/load'
export const ROLEFORM_FETCHITEM_SUCCEED = 'roleForm/fetchItem/succeed'
export const ROLEFORM_FETCHITEM_FAIL = 'roleForm/fetchItem/fail'
export const ROLEFORM_CREATEITEM_LOAD = 'roleForm/createItem/load'
export const ROLEFORM_CREATEITEM_SUCCEED = 'roleForm/createItem/succeed'
export const ROLEFORM_CREATEITEM_FAIL = 'roleForm/createItem/fail'
export const ROLEFORM_EDITITEM_LOAD = 'roleForm/editItem/load'
export const ROLEFORM_EDITITEM_SUCCEED = 'roleForm/editItem/succeed'
export const ROLEFORM_EDITITEM_FAIL = 'roleForm/editItem/fail'
export const ROLEFORM_DELETEITEM_LOAD = 'roleForm/deleteItem/load'
export const ROLEFORM_DELETEITEM_SUCCEED = 'roleForm/deleteItem/succeed'
export const ROLEFORM_DELETEITEM_FAIL = 'roleForm/deleteItem/fail'

export const ROLEBUTTONMENUFORM_ENTER_RESET = 'roleButtonMenuForm/enter/reset'
export const ROLEBUTTONMENUFORM_FETCHITEMS_LOAD = 'roleButtonMenuForm/fetchItems/load'
export const ROLEBUTTONMENUFORM_FETCHITEMS_SUCCEED = 'roleButtonMenuForm/fetchItems/succeed'
export const ROLEBUTTONMENUFORM_FETCHITEMS_FAIL = 'roleButtonMenuForm/fetchItems/fail'
export const ROLEBUTTONMENUFORM_EDITFORM_CHANGE = 'roleButtonMenuForm/editForm/change'
export const ROLEBUTTONMENUFORM_EDITITEM_LOAD = 'roleButtonMenuForm/editItem/load'
export const ROLEBUTTONMENUFORM_EDITITEM_SUCCEED = 'roleButtonMenuForm/editItem/succeed'
export const ROLEBUTTONMENUFORM_EDITITEM_FAIL = 'roleButtonMenuForm/editItem/fail'

export const USERSELLERMENUFORM_ENTER_RESET = 'userSellerMenuForm/enter/reset'
export const USERSELLERMENUFORM_FETCHITEMS_LOAD = 'userSellerMenuForm/fetchItems/load'
export const USERSELLERMENUFORM_FETCHITEMS_SUCCEED = 'userSellerMenuForm/fetchItems/succeed'
export const USERSELLERMENUFORM_FETCHITEMS_FAIL = 'userSellerMenuForm/fetchItems/fail'
export const USERSELLERMENUFORM_EDITFORM_CHANGE = 'userSellerMenuForm/editForm/change'
export const USERSELLERMENUFORM_EDITITEM_LOAD = 'userSellerMenuForm/editItem/load'
export const USERSELLERMENUFORM_EDITITEM_SUCCEED = 'userSellerMenuForm/editItem/succeed'
export const USERSELLERMENUFORM_EDITITEM_FAIL = 'userSellerMenuForm/editItem/fail'

export const CHATBOTS_BUTTONS_CONTROLLER_FETCH_ITEMS_LOAD = 'chatbotsButtonsController/fetchItems/load'
export const CHATBOTS_BUTTONS_CONTROLLER_FETCH_ITEMS_SUCCEED = 'chatbotsButtonsController/fetchItems/succeed'
export const CHATBOTS_BUTTONS_CONTROLLER_FETCH_ITEMS_FAIL = 'chatbotsButtonsController/fetchItems/fail'
export const CHATBOTS_BUTTONS_CONTROLLER_EDITFORM_CHANGE = 'chatbotsButtonsController/editForm/change'
export const CHATBOTS_BUTTONS_CONTROLLER_EDITFORM_LOAD = 'chatbotsButtonsController/editForm/load'
export const CHATBOTS_BUTTONS_CONTROLLER_EDITFORM_SUCEED = 'chatbotsButtonsController/editForm/succeed'
export const CHATBOTS_BUTTONS_CONTROLLER_EDITFORM_FAIL = 'chatbotsButtonsController/editForm/fail'
export const CHATBOTS_BUTTONS_CONTROLLER_ENTER_RESET = 'chatbotsButtonsController/enter/reset'



// WEBPACK FOOTER //
// src/constants/actionTypes.js